import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  // Prüfen, ob es eine Policy-Seite ist
  const isPolicyPage = pathname.startsWith("/privacy-policy") ||
                       pathname.startsWith("/terms-of-service") ||
                       pathname.startsWith("/refund-policy");

  // Prüfen, ob ein Popup in der URL existiert
  const hasPopup = new URLSearchParams(search).has("popup");

  // Prüfen, ob der Klick aus dem Footer kommt
  const isFromFooter = sessionStorage.getItem("fromFooterClick") === "true";

  useEffect(() => {
    const fromSwitcher = sessionStorage.getItem("fromPolicySwitcher") === "true";
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      // Auf mobilen Geräten wird immer zu einer bestimmten Position gescrollt, z.B. Y = 100
      window.scrollTo(0, 400);
    }
    // 🔥 Nur scrollen, wenn der Klick aus dem Footer kommt
    else if  (isFromFooter && !hasPopup && (!isPolicyPage || !fromSwitcher)) {
      window.scrollTo(0, 0);
    }

    // Nach dem ersten Wechsel zurücksetzen
    sessionStorage.removeItem("fromPolicySwitcher");
    sessionStorage.removeItem("fromFooterClick");

  }, [pathname, search, isPolicyPage, hasPopup, isFromFooter]);

  return null;
};

export default ScrollToTop;
